import { jsx as _jsx } from "react/jsx-runtime";
import './Component_PrettyPrint_Number.scss';
import { PPDescription } from '../../Component_PrettyPrint_Description/Component_PrettyPrint_Description.js';
export const Component_PrettyPrint_Number = (props) => {
    return _jsx(PPDescription, { className: 'number-description', children: props.expression.value });
};
//# sourceMappingURL=Component_PrettyPrint_Number.js.map